export default __webpack_public_path__ + "static/media/dots3.d89b32d8.webp";